export const BU = {
  Indigo: 'Indigo',
  LF: 'LF',
  Scitex: 'Scitex',
  PWI: 'PWI',
};

export const PILLAR = {
  Optimize: 'Optimize',
  Automate: 'Automate',
  Grow: 'Grow',
};
// id: landing page identifier for application - drives Name and Description
// appId: application id associated with this item - drives Icon
// name: display name for application
// desc: description for the application
// icon: cdn reference to icon associated with the application
// bgImage: cdn reference to image to associate with the application
// pillar: Which pillar is the application associated with?
// businessUnits: Which business units is this application associated with?
export const appDefinitions = [
  {
    id: 'print-beat',
    appId: 'printbeat',
    bgImage: 'url("https://picsum.photos/id/773/1920/1080")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.LF, BU.PWI, BU.Scitex],
    priority: 1000,
    content: [
      {
        type: 'testimonial',
        businessUnits: [BU.Indigo, BU.PWI, BU.Scitex],
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/gls_logo.png',
          quote: '<b>Print Beat</b> gives you all the answers - in one place, at one time.',
          picture: 'https://cdn.printos.com/apps/home/0.1.473/components/welcome/img/pb-quote-ref.jpg',
          name: 'Dave Manship',
          title: 'Digital Operations Manager',
          company: '<a class=\"company-link\" href=\"https://www.glsprecisionmarketing.com/\" target=\"_blank\">GLS Companies</a>',
        }
      },
      {
        type: 'video',
        businessUnits: [BU.Indigo, BU.PWI, BU.Scitex],
        videoIds: {
          en: '86BHQ1vGzyM',
        }
      },
      {
        type: 'image',
        businessUnits: [BU.LF],
        ga: {
          title: 'Carousel Link Click - printbeat - lf-dashboard',
          options: {category:'landing-page'},
        },
        path: 'https://cdn.printos.com/images/market/products/summary/print-beat/lf-printbeat-dashboard-blog.png',
        link: 'https://hplatexknowledgecenter.com/blog/near-real-time-monitoring-new-hp-print-beat-dashboard',
        message: 'Remote Monitoring with the new HP Print Beat Dashboard',
      },
      {
        type: 'image',
        businessUnits: [BU.LF],
        ga: {
          title: 'Carousel Link Click - printbeat - lf-report',
          options: {category:'landing-page'},
        },
        path: 'https://cdn.printos.com/images/market/products/summary/print-beat/lf-printbeat-report-blog.png',
        link: 'https://hplatexknowledgecenter.com/blog/real-time-analytics-new-hp-print-beat-reports',
        message: 'Real-Time Analytics with the new HP Print Beat Reports',
      },
      {
        type: 'video',
        businessUnits: [BU.LF],
        videoIds: {
          en: 'WOM0SpQCUZM',
        }
      },
      {
        type: 'video',
        businessUnits: [BU.LF],
        videoIds: {
          en: 'd430-nHfTmg',
        }
      },
    ],
  },
  {
    id: 'media-locator',
    appId: 'ml',
    bgImage: 'url("https://picsum.photos/id/667/1920/1080")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI],
    priority: 150,
    content: [
      {
        type: 'testimonial',
        businessUnits: [BU.Indigo, BU.Scitex, BU.PWI],
        options: {
          layout: 'personal-1',
          companyname: 'Deja Link',
          logo: 'https://cdn.printos.com/images/market/products/summary/media-locator/dejalink-logo2.jpg',
          picture: 'https://cdn.printos.com/images/market/products/summary/media-locator/laurent_caviale.jpg',
          quote: 'Thanks to HP PrintOS Media Locator, we also have a cloud-based database of paper suppliers.  It\'s a very useful tool for immediately establishing if a paper type requested by a customer is compatible with our HP Indigo presses.',
          name: 'Laurent Caviale',
          title: 'General Director',
          company: '<a class="company-link" href="http://dejalink.fr/" target="_blank">Deja Link</a>',
        }
      },
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/benson-logo.jpg',
          quote: 'I use the <b>Media Locator</b> a lot.  I wanna see what\'s out there, what I can do.',
          picture: 'https://cdn.printos.com/apps/home/0.1.473/components/welcome/img/ml-quote-ref.jpg',
          name: 'Brian Benson',
          title: 'CEO',
          company: '<a class=\"company-link\" href=\"https://www.yourbenson.com/\" target=\"_blank\">Benson Integrated Marketing</a>',
        }
      },
      {
        type: 'video',
        videoIds: {
          en: 'P1FpauyAPmc',
        }
      },
    ],
  },
  {
    id: 'knowledge-zone',
    appId: 'information-center',
    bgImage: 'url("https://picsum.photos/id/108/1920/1080")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.PWI, BU.Scitex],
    priority: 200,
    content: [
      {
        type: 'testimonial',
        businessUnits: [BU.Indigo],
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/superior_logo.png',
          quote: 'HP has helped us grow our business 35-40%.  Their platform is the key to our success.',
          picture: 'https://cdn.printos.com/apps/home/0.1.473/components/welcome/img/kz-quote-ref.jpg',
          name: 'Dan Charlebois',
          title: 'Owner',
          company: '<a class=\"company-link\" href=\"https://www.superiorpackagingandfinishing.com\" target=\"_blank\">Superior Packaging and Finishing</a>',
        }
      },
      {
        type: 'video',
        videoIds: {
          en: 'Ing0Q22zodA',
        }
      },
      {
        type: 'video',
        videoIds: {
          en: 'CTHkfx-1E9U',
        }
      },
    ],
  },
  {
    id: 'print-beat-mobile',
    appId: 'print-beat-mobile',
    title: 'HP PrintOS Mobile App', //Temporary english-only override until portal can be delivered
    desc: 'Keep up to date with your print operations virtually, anytime, anywhere.', //Temporary english-only override until portal can be delivered
    bgImage: 'url("https://picsum.photos/id/857/1920/1080")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.LF],
    priority: 900,
    content: [
      {
        type: 'video',
        videoIds: {
          en: '_ZyI-Xn4E4I',
        }
      },
    ],
  },
  {
    id: 'service-center',
    appId: 'pwi-sc',
    bgImage: 'url("https://picsum.photos/id/1022/1920/1080")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI],
    priority: 500,
    content: [
      {
        type: 'image',
        businessUnits: [BU.LF],
        ga: {
          title: 'Carousel Link Click - service-center - lf-activities',
          options: {category:'landing-page'},
        },
        path: 'https://cdn.printos.com/images/market/products/summary/service-center/lf-service-center-blog.jpg',
        link: 'https://hplatexknowledgecenter.com/blog/direct-access-your-service-activities-hp-printos-service-center',
        message: 'Direct access to your service activities with the HP PrintOS Service Center',
      },
      {
        type: 'video',
        videoIds: {
          en: '3-Jirj0EfRM',
        }
      },
    ],
  },
  // {
  //   id: 'service-center-channels',
  //   appId: 'reseller-portal',
  //   bgImage: 'url("https://picsum.photos/id/902/1920/1080")',
  //   pillar: PILLAR.Optimize,
  //   businessUnits: [BU.LF],
  //   priority: 500,
  //   content: [
  //      {
  //        type: 'video',
  //        videoIds: {
  //          en: '5aivpAI15VA'
  //        },
  //      },
  //   ],
  // },
  {
    id: 'substrate-manager',
    appId: 'csm',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/1.jpg")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo],
    priority: 100,
    content: [
      {
        type: 'testimonial',
        options: {
          style: {
            dark: true,
            quoteColor: '#ffffff',
          },
          layout: 'personal-5',
          image2: 'https://cdn.printos.com/images/market/products/summary/csm/gls-companies1.png',
          // headline: 'Accuracy and consistency',
          quote: 'With PrintOS Substrate manager, it is easier to run jobs on all paper types across multiple presses and get consistent, high quality results, quickly with minimal effort.',
          name: 'Larry Knutson',
          title: 'Indigo Operator',
          company: 'GLS'
        }
      },
      {
        type: 'testimonial',
        options: {
          style: {
            dark: true,
            quoteSize: '14px',
            quoteColor: '#ffffff',
          },
          layout: 'personal-6',
          image2: 'https://cdn.printos.com/images/market/products/summary/csm/millers.jpg',
          // companyname: 'Millers Professional Imaging',
          // headline: 'Improve consistency across HP Indigo presses',
          quote: 'We strive for color perfection across numerous substrates and have really found Substrate Manager giving us peace of mind knowing all of our settings are uniform across our Indigo fleet. Substrate Manager is very easy to set up and share the same substrate settings across our fleet of Indigos. I also like the fact that we can share our settings with our sites in Columbia, MO. I also like that I can make the change in the Substrate Manager and then share it across my fleet without having to build it on each press.',
          name: 'Steve Morrison',
          title: 'Indigo Supervisor',
          company: 'Millers Professional Imaging',
        }
      },
      {
        type: 'video',
        videoIds: {
          en: 'UsGUZOfrgnI'
        },
      },
    ],
  },
  {
    id: 'configuration-center',
    appId: 'color-config',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/9.jpg")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.LF],
    priority: 900,
    content: [
      {
        type: 'image',
        businessUnits: [BU.LF],
        ga: {
          title: 'Carousel Link Click - configuration-center - lf-monitor',
          options: {category:'landing-page'},
        },
        path: 'https://cdn.printos.com/images/market/products/summary/configuration-center/lf-configuration-center-monitor-blog.png',
        link: 'https://hplatexknowledgecenter.com/blog/monitor-and-control-your-printer-configurations-across-all-sites-new-hp-configuration-center',
        message: 'Monitor and Control your printer configurations across all sites with the new HP Configuration Center',
      },
      {
        type: 'image',
        businessUnits: [BU.LF],
        ga: {
          title: 'Carousel Link Click - configuration-center - lf-package',
          options: {category:'landing-page'},
        },
        path: 'https://cdn.printos.com/images/market/products/summary/configuration-center/lf-configuration-center-package-blug.jpg',
        link: 'https://hplatexknowledgecenter.com/blog/create-and-deploy-substrate-packages-3-easy-steps-new-hp-configuration-center',
        message: 'Create and Deploy substrate packages in 3 easy steps with the new HP Configuration Center',
      },
      {
        type: 'video',
        businessUnits: [BU.LF],
        videoIds: {
          en: 'AWTe1ue6uYs',
        }
      },
      {
        type: 'video',
        businessUnits: [BU.LF],
        videoIds: {
          en: 'wao1HWDCj9k',
        }
      },
    ],
  },
  {
    id: 'jobs-api',
    appId: 'jobs',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/16.jpg")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo],
    priority: 400,
    content: [
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/jobsapi/sundance-logo.png',
          quote: 'PrintOS Print Beat Jobs API allows us to take more business decisions based on hard data, rather than relying on gut feeling and perception',
          picture: 'https://cdn.printos.com/images/market/products/summary/jobsapi/sundance-testimonial2.jpg',
          name: 'Susanna Toppa',
          title: 'Creative Director',
          company: '<a class=\"company-link\" href=\"https://sundanceusa.com/\" target=\"_blank\">SunDance</a>',
          showVariant: false,
        },
      }
    ],
  },
  {
    id: 'site-flow',
    appId: 'production',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/18.jpg")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo, BU.Scitex, BU.PWI],
    priority: 1000,
    content: [
      {
        type: 'video',
        videoIds: {
          en: '3mZA8Y63Af8',
          de: 'YemkmKTNYQE',
          es: '5hnOFdjJQOw',
          fr: 'dt6WMULg7xM',
          it: 'pJyLo4so4gY',
          ko: 'OydKWAoXOJY',
          pt: 'aiGbk14o_mA',
          zh: 'iEExJW8-43Y',
        },
      },
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/superior_logo.png',
          quote: '<b>Site Flow</b> has allowed us to secure new business directly related to its speed and versatility.',
          picture: 'https://cdn.printos.com/apps/home/0.1.473/components/welcome/img/sf-quote-ref.jpg',
          name: 'Toby McManus',
          title: 'Director of Business Management',
          company: '<a class=\"company-link\" href=\"https://www.superiorpackagingandfinishing.com/\" target=\"_blank\">Superior Packaging and Finishing</a>',
        },
      },
      {
        type: 'image',
        path: 'siteflow1.png',
      },
    ],
  },
  {
    id: 'box',
    appId: 'box',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/41.jpg")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo, BU.Scitex, BU.PWI],
    priority: 900,
    content: [
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/univest_logo.png',
          quote: '<b>Box</b> allows us to get files to the Press in the most efficient way.',
          picture: 'https://cdn.printos.com/apps/home/0.1.473/components/welcome/img/box-quote-ref.jpg',
          name: 'Aleksy Satronov',
          title: 'Prepress Manager',
          company: '<a class=\"company-link\" href=\"https://www.upp.ua/\" target=\"_blank\">Univest</a>',
        },
      },
      {
        type: 'video',
        videoIds: {
          en: 'omfsa8CNg5I'
        },
      },
    ],
  },
  {
    id: 'composer',
    appId: 'composer',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/42.jpg")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo, BU.Scitex, BU.PWI],
    priority: 700,
    content: [
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/composer/company-wihabo.jpg',
          quote: 'PrintOS Composer has been greatly effective in delivering our award winning <a class=\"link\" href=\"https://www.wihabo.nl/vers-van-de-pers/tony-s-limited-editions-are-really-one-of-a-kind\" target=\"_blank\">Tony\'s Chocolonely</a> VDP project quickly and accurately.',
          picture: 'https://cdn.printos.com/images/market/products/summary/composer/wihabo-testimonial1.jpg',
          name: 'Mike Rovers',
          title: 'Studio Manager',
          company: '<a class=\"company-link\" href=\"https://www.wihabo.nl/\" target=\"_blank\">Wihabo</a>',
        }
      },
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          style: {
            logoBGColor: '#ffffff',
          },
          logo: 'https://cdn.printos.com/images/market/products/summary/composer/company-feburman.png',
          quote: 'Creating the <a class=\"link\" href=\"http://www.hellorichard.co.uk/?portfolio=fes-watch-u-x-g-f-smith" target=\"_blank\">Sony FES Watch U</a> campaign, required a robust Variable PDF creation tool.  PrintOS Composer provided us with exactly what we needed.',
          picture: 'https://cdn.printos.com/images/market/products/summary/composer/feburman-testimonial1.jpg',
          name: 'Roger White',
          title: 'Creative & Technical Lead',
          company: '<a class=\"company-link\" href=\"https://www.feburman.co.uk/\" target=\"_blank\">F.E. Burman</a>',
        }
      },
      {
        type: 'video',
        videoIds: {
          en: 'WUvQ3KIqDd4',
        }
      },
    ],
    // learn: {
    //   link: 'https://hp.com',
    // }
  },
  {
    id: 'imposer',
    appId: 'imposer',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/43.jpg")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo, BU.Scitex, BU.PWI],
    priority: 600,
    content: [
      {
        type: 'video',
        videoIds: {
          en: 'At77w-mghUo'
        },
      },
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/superior_logo.png',
          quote: 'Those are the tools we use to catapult us as a digital printer.',
          picture: 'https://cdn.printos.com/apps/home/0.1.473/components/welcome/img/kz-quote-ref.jpg',
          name: 'Dan Charlebois',
          title: 'Owner',
          company: '<a class=\"company-link\" href=\"https://www.superiorpackagingandfinishing.com\" target=\"_blank\">Superior Packaging and Finishing</a>',
        }
      },
    ],
  },
  {
    id: 'resource-manager',
    appId: 'resourcemanager',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/45.jpg")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo],
    priority: 300,
    content: [
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/itek-logo.png',
          quote: 'Using the HP PrintOS Resource Manager I am able to click on one site and see all aspects of my DFE, ticket templates, look up tables, substrates, at a glance just by using one application',
          picture: 'https://cdn.printos.com/apps/home/0.1.473/components/welcome/img/rm-quote-ref.jpg',
          name: 'Doug Rembold',
          title: 'Digital Production Manager',
          company: '<a class=\"company-link\" href=\"https://itekrocks.com/\" target=\"_blank\">iTEK</a>',
        }
      },
      {
        type: 'video',
        videoIds: {
          en: 'xdako_WrlAk'
        },
      },
      {
        type: 'video',
        videoIds: {
          en: 'pnBKLQ1BDC8'
        },
      },
    ],
  },
  {
    id: 'applications-center',
    appId: 'wallart',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/39.jpg")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.LF],
    priority: 500,
    content: [
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          style: {
            logoBGColor: '#ffffff',
          },
          logo: 'https://cdn.printos.com/images/market/products/summary/jds-partners-logo.png',
          quote: 'HP Applications Center makes up a major part of our business growth strategy.',
          picture: 'https://cdn.printos.com/apps/home/0.1.473/components/welcome/img/wallart-quote-ref.jpg',
          name: 'James Belcher',
          title: 'Managing Director',
          company: '<a class=\"company-link\" href=\"https://itekrocks.com/\" target=\"_blank\">iTEK</a>',
        }
      },
      {
        type: 'video',
        videoIds: {
          en: 'OCPyE3ABFBg'
        },
      },
    ],
  },
  {
    id: 'marketplace-licenses',
    appId: 'marketplace',
    bgImage: 'url("https://cdn.printos.com/images/signin/1280x1024/25.jpg")',
    pillar: PILLAR.Grow,
    businessUnits: [BU.Indigo],
    priority: 500,
  },
  {
    id: 'marketplace-ideas',
    appId: 'marketplace',
    bgImage: 'url("https://picsum.photos/id/631/1920/1080")',
    pillar: PILLAR.Grow,
    businessUnits: [BU.Indigo],
    priority: 600,
  },
];



// WEBPACK FOOTER //
// ./components/landing-content/app-definitions.js